import React from 'react';
import { Shield } from 'lucide-react';

import { Alert, AlertDescription } from './ui/alert';

interface ConsequenceAlertProps {
  children: React.ReactNode;
  className?: string;
}

/**
 * The amber "this reaches beyond one organization" warning (DESIGN_SYSTEM §2):
 * a warning Alert with the Shield, placed inside the confirmation or form where
 * the decision is made. It never recolours a button or a switch.
 *
 * `role="status"`, not the Alert primitive's default `role="alert"`: it is
 * standing information present when the dialog opens, not a failure, and the
 * dialog's own error line keeps the one `role="alert"` slot.
 */
export const ConsequenceAlert: React.FC<ConsequenceAlertProps> = ({ children, className }) => (
  <Alert variant="warning" role="status" className={className}>
    <Shield aria-hidden="true" />
    <AlertDescription>{children}</AlertDescription>
  </Alert>
);

export default ConsequenceAlert;
